@if (translateString) {
  <span>
    {{ translateString }}
  </span>
}
